import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';
import CompanyEditPage from '@/features/companies/company-edit/CompanyEditPage';
import CompanyEditSuccessPage from '@/features/companies/company-edit-success/CompanyEditSuccessPage';

export const companyEditRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/companies/$companyId/edit',
  component: CompanyEditPage,
});

export const companyEditSuccessRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/companies/$companyId/edit/success',
  component: CompanyEditSuccessPage,
});
